import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography } from 'seagull';
import { SecuritySafe, Lock } from 'seagull/icons';
import { Visa, MasterCard } from './BankSecurityRow.icons';
import styles from './BankSecurityRow.module.scss';
import americanExpressUrl from './images/american-express.png';
import discoverUrl from './images/discover.png';
export default function BankSecurityRow(props) {
    const { className, mobileView } = props, rest = _object_without_properties(props, [
        "className",
        "mobileView"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: cn(styles.root, className, {
            [styles.mobileView]: mobileView
        })
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                skin: "disabled",
                children: "Bank-level security and privacy."
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.icons,
                children: [
                    /*#__PURE__*/ _jsx(SecuritySafe, {}),
                    /*#__PURE__*/ _jsx(Visa, {}),
                    /*#__PURE__*/ _jsx("img", {
                        src: discoverUrl,
                        height: 31,
                        width: 82,
                        alt: "Discover logo"
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: americanExpressUrl,
                        height: 32,
                        width: 32,
                        alt: "American Express logo"
                    }),
                    /*#__PURE__*/ _jsx(MasterCard, {}),
                    /*#__PURE__*/ _jsx(Lock, {})
                ]
            })
        ]
    }));
}
